import { blurImageURL } from "/lib/publicEnv.js";
import Tilt from "react-parallax-tilt";

import { useState } from 'react';

import Image from 'next/image';
import { FaCalendar, FaClock, FaCrown, FaMoneyBill } from 'react-icons/fa';
import Link from "next/link";
import { MdLocationPin } from "react-icons/md";

export default function Thumbnail(props) {
    const [thumbSrc, setThumbSrc] = useState(props.thumb);
    function GetThumbnail() {
        return (
            <> 
                <div className={`bg-gray-900 flex flex-col w-full gap-y-4 h-full min-w-[300px] md:min-w-[400px] max-w-[600px] md:max-w-[800px] min-h-[200px] px-6 pr-12 py-4 pb-12 items-center`}>
                    {
                        props?.catData?.background && (
                            <div 
                                style={{
                                    backgroundColor: props.catData?.background?.hex,
                                }}
                                className="absolute top-0 left-0 w-[10px] h-full z-10"
                            />
                        )
                    }
                    <div className="absolute top-4 left-6 flex flex-row items-center justify-between w-[90%] sm:w-[93.5%] md:w-[90%] lg:w-[90%] xl:w-[90%] 2xl:w-[92%] 3xl:w-[90%]">
                        {
                            props?.icon && (
                                <div className="absolute w-full h-full flex">
                                    <img
                                        src={props?.icon}
                                        alt={props?.title}
                                        className="rounded-2xl w-[5rem] h-[5rem]"
                                    />
                                </div>
                            )
                        }
                        <div className="flex flex-col w-full items-end">
                            <span className={`text-xl font-BreezeAltHeader text-right w-full ${props.icon ? "max-w-[250px]" : "max-w-[275px]"}`}>{props.title}</span>
                            <span className={`text-xl font-BreezeAltHeader font-medium text-right whitespace-normal ${props?.icon ? "max-w-[250px]" : "max-w-[275px]"}`}>{props.tagline}</span>
                        </div>
                    </div>
                    <div className="px-4 pl-6 w-full h-[90px] absolute bottom-0 left-0 flex flex-row justify-between items-center">
                        <span className={`bg-gray-900 flex flex-col gap-y-2 items-start text-md text-left font-medium leading-4 rounded-md z-20`}>
                            <div className="flex flex-row gap-x-2">
                                <FaClock /> {props.cadence}
                            </div>
                            <div className="flex flex-row gap-x-2">
                                <MdLocationPin /> {props.location}
                            </div>
                        </span>
                        <span className="flex flex-col gap-y-2 items-end text-md text-right font-medium leading-4 rounded-md z-20">
                            <div className="flex flex-row gap-x-2">
                                {props.pay} <FaMoneyBill />
                            </div>
                            <div className="flex flex-row gap-x-2">
                                {props.begins} <FaCalendar /> 
                            </div>
                        </span>
                    </div>
                </div>
            </>
        )
    }

    return (
        <Link href={`/jobs/p/${props.id}`}>
            <div className="flex flex-col gap-y-3">
                <div rel="noreferrer" target="_blank" className="rounded-2xl">
                    <div className="transform hover:scale-105 block group relative w-full bg-transparent transition-all ease-in-out duration-300 rounded-2xl overflow-hidden">             
                        <GetThumbnail />
                    </div>
                </div>
                <div>
                    <div className="flex flex-col gap-y-2">
                        <div className="flex flex-row gap-x-2 items-start">
                            <span className="font-BreezeAltHeader font-medium text-sm flex flex-col">
                                <div rel="noreferrer" target="_blank" className={`font-BreezeAltHeader font-bold hover:text-gray-300 transition-all ease-in-out duration-200`}>{props.none}</div>
                                <div className="flex flex-row gap-x-1 font-semibold">
                                    <div href={props.authorHref} target="_blank" rel="noreferrer noopener"> {
                                    props.authorId === "UCxlyTwuE1uuieLnl_tjBYVQ" ? (
                                        <span className="flex gap-x-1 items-center">
                                            Kooleyy <FaCrown className="text-yellow-400 w-5" />
                                        </span>
                                    ) : props.author
                                    }</div>{props.views ? ` · ${Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(props.views)} views` : null}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};